<template>
  <canvas class="graph-canvas"></canvas>
</template>

<script>
import _find from 'lodash/find'
import _sum from 'lodash/sum'
import _countBy from 'lodash/countBy'
import _size from 'lodash/size'
import workerUrl from 'worker-plugin/loader!./graph.worker.js' // eslint-disable-line

const d3 = Object.assign({}, require('d3-selection'))

let uid = 0

export default {
  inject: {icons: 'graphIcons'},
  props: ['dataset', 'alldata'],
  data () {
    return {
      canvas: null,
      context: null,
      width: 100,
      height: 100,
      simulation: null,
      nodes: [],
      strength: -1.90, // default repulsion
      centeringStrength: 0.01, // power of centering force for two clusters
      outerRadius: 350, // new nodes within this radius
      innerRadius: 100, // new nodes outside this radius, initial nodes within.
      startCenter: [], // new nodes/initial nodes center point coordinates
      // endCenter: [], // destination center coordinates
      n: 1, // number of initial nodes
      tick: 0,
      oldDataset: {totals: []},
      isSimulationStopped: false,
      iconScale: 1.99,
      infosize: 20,
      groupCounts: []
    }
  },
  watch: {
    'dataset': function (newVal, oldVal) {
      if (!newVal || !newVal.totals.length) return

      if (!this.oldDataset.totals.length) {
        //
      }

      if (oldVal && oldVal.totals) {
        this.oldDataset = oldVal
      }

      // this.n = newVal.totals.reduce((a, b) => +a + +b, 0) // sum of the array

      if (this.simulation) {
        this.isSimulationStopped = true
        this.simulation.stop()
      }

      this.initSets()
    }
  },
  methods: {
    initSets () {
      this.nodesAll = []
      this.links = []
      this.startCenters = []
      this.endCenters = []
      this.iconSize = [15, 15 * this.iconScale] // [width,height]
      var strength = -1.90 // default repulsion

      var xlength = (this.width - 20) / this.dataset.totals.length
      var ylength = (this.height) / this.dataset.totals.length
      this.dataset.totals.forEach((element, index) => {
        this.oldDataset.totals.push(0)
        this.nodes.push([])

        var cx = (xlength * (index + 1)) - (xlength / 2)
        var cy = (ylength * (index + 1)) - (ylength / 2)
        if (this.width < 768) {
          // cx = (xlength * (index + 1)) - (xlength / 2)
          cx = (this.width / 2)
          cy = (ylength * (index + 1)) - (ylength / 2)
        } else {
          cx = (xlength * (index + 1)) - (xlength / 2)
          cy = this.height / 2
          if (this.width > 960) {
            strength = -3.00
            this.iconSize = [20, 20 * this.iconScale]
          }
        }
        this.startCenters.push([cx - (this.iconSize[0] / 2), cy - (this.iconSize[1] / 2)]) // new nodes/initial nodes center point coordinates
      })
      if (this.dataset.totals.length && _sum(this.dataset.totals) < 15) {
        this.iconSize = [30, 30 * this.iconScale]
        strength = -10.00
      } else if (this.dataset.totals.length && _sum(this.dataset.totals) < 41) {
        this.iconSize = [25, 25 * this.iconScale]
        strength = -6.00
      } else if (this.dataset.totals.length < 3) {
        this.iconSize = [18, 18 * this.iconScale]
        strength = -2.50
        if (this.width > 768) {
          this.iconSize = [20, 20 * this.iconScale]
          strength = -5.00
        }
      }
      this.iconSize = [this.iconSize[0] + 6, (this.iconSize[0] + 6) * this.iconScale]
      this.strength = strength
      if (!this.nodesAll.length) {
        this.dataset.info[0].forEach((item) => {
          const newNode = this.newNode(0, item)
          this.nodesAll.unshift(newNode)
        })
        if (this.dataset.externalconnection) {
          const connection = _find(this.alldata, (o) => {
            return this.dataset.externalconnection['case-connections-outside-cluster'] === o['case-number']
          })
          if (connection) {
            const newNode = this.newNode(0, connection, true)
            this.nodesAll.unshift(newNode)
            this.nodesAll.forEach((item) => {
              if (item.info['case-connections-outside-cluster'] === connection['case-number']) {
                this.links.push({source: item, target: newNode})
              }
            })
            // const source = _find(this.nodesAll, (o) => {
            //   return o.info['case-connections-outside-cluster'] === connection['case-number']
            // })
            // if (source) {
            //   this.links.push({source: source, target: newNode})
            // }
          }
        }
      }
      this.initGraph()
    },
    initGraph () {
      const self = this
      this.tick = 0
      this.isSimulationStopped = false

      var groupCounts = []
      this.dataset.info.forEach((element, index) => {
        const counts = _countBy(element, (item) => {
          return item['case-connections-within-cluster']
        })
        const sorted = Object.keys(counts)
        groupCounts.push({count: _size(counts), case: counts, sorted, info: new Array(sorted.length)})
      })
      this.groupCounts = groupCounts

      this.nodesAll.forEach((element, index) => {
        var found = false
        this.dataset.info.forEach((item, i) => {
          if (!found) {
            found = _find(item, (o) => {
              return o['case-number'] === element.info['case-number']
            })
            if (found) {
              element.nindex = i
              if (this.dataset.key) {
                var indexGroup = groupCounts[i].sorted.indexOf(element.info['case-connections-within-cluster'] + '')
                if (groupCounts[i].case[element.info['case-number']]) {
                  indexGroup = groupCounts[i].sorted.indexOf(element.info['case-number'] + '')
                }
                element.group = indexGroup
                // element.x = Math.cos(indexGroup / (groupCounts[i].sorted.length) * 2 * Math.PI) * 200 + (this.width / 2 - (this.iconSize[1] / 2)) + Math.random()
                // element.y = Math.sin(indexGroup / (groupCounts[i].sorted.length) * 2 * Math.PI) * 200 + this.height / 2 - (this.iconSize[1] / 2) + Math.random()
                element.x = this.width / 2
                element.y = this.height / 2
                if (!this.groupCounts[i].info[indexGroup] || groupCounts[i].case[element.info['case-number']]) {
                  this.groupCounts[i].info[indexGroup] = element
                }
                const connection = _find(this.nodesAll, (o) => {
                  return o.info['case-number'] === element.info['case-connections-within-cluster']
                })
                if (connection) {
                  this.links.push({source: element, target: connection})
                }
              }
            }
          }
        })
        if (!found) {
          element.nindex = -1
        }
      })

      const worker = new Worker(workerUrl, {type: 'module'})
      worker.onmessage = e => {
        this.nodesAll = e.data
        this.links = this.links.map(link => {
          return {
            source: e.data.find(node => node.id === link.source.id),
            target: e.data.find(node => node.id === link.target.id)
          }
        })
        this.ticked()
        this.drawLink()
      }

      const message = {
        nodes: this.nodesAll,
        links: this.links,
        context: {
          width: this.width,
          height: this.height,
          iconSize: this.iconSize,
          infosize: this.infosize
        }
      }
      worker.postMessage(message)
    },
    newNode (index, info, isExternal = false) {
      // const angle = Math.random() * Math.PI * 2
      // const distance = Math.random() * (this.outerRadius - this.innerRadius) + this.innerRadius
      // var x = Math.cos(angle) * distance + this.startCenters[index][0]
      // var y = Math.sin(angle) * distance + this.startCenters[index][1]
      var iconIndex = 0
      if (info.gender && info.gender.toLowerCase() === 'female') {
        iconIndex = 1
      }
      if (+info.age <= 2) {
        iconIndex = 4
      } else if (+info.age >= 65) {
        iconIndex = 5
        if (info.gender && info.gender.toLowerCase() === 'female') {
          iconIndex = 6
        }
      } else if (+info.age <= 14) {
        iconIndex = 2
        if (info.gender && info.gender.toLowerCase() === 'female') {
          iconIndex = 3
        }
      }

      return {
        id: uid++,
        x: this.width / 2,
        y: this.height / 2,
        fx: isExternal ? this.width - 50 : null,
        fy: isExternal ? 50 : null,
        radius: (this.iconSize[1] + this.infosize) / 2,
        nindex: index,
        migrated: false,
        iconIndex,
        info: Object.assign({}, info),
        isExternal
      }
    },
    ticked (params) {
      const self = this

      // draw
      // const removeOpacity = 0.6 - (this.tick / this.innerRadius)
      this.context.clearRect(0, 0, this.width, this.height)
      var fontSize = self.iconSize[0] * 0.40 > 10 ? 10 : self.iconSize[0] * 0.40
      this.nodesAll.forEach(function (d, i) {
        if (d.isExternal) {
          // external connections
          self.context.beginPath()
          self.context.arc(d.x, d.y, 15, 0, 2 * Math.PI)
          self.context.fillStyle = '#C0CAC9'
          self.context.fill()

          fontSize = 10
          self.context.font = `${fontSize}px CuratorRegular`
          self.context.fillStyle = '#FFF'
          self.context.textAlign = 'center'
          // self.context.fillText(d.info['case-number'], d.x, d.y + 4)
        } else {
          // internal connections
          self.context.globalAlpha = d.nindex < 0 ? 0 : 1

          self.context.drawImage(self.icons[d.iconIndex], d.x, d.y, self.iconSize[0], self.iconSize[1])

          self.iconColor(d)

          // show case number
          fontSize = self.iconSize[0] * 0.40 > 8 ? 8 : self.iconSize[0] * 0.30
          var adjustedy = d.info.age > 14 ? 0 : (d.info.age > 2 ? 7 : 3)
          if (d.info.age < 14 && d.info.age > 2) {
            fontSize = 6
          }
          self.context.font = `${fontSize}px CuratorRegular`
          self.context.fillStyle = isNaN(d.info.age) || d.info.age > 2 ? '#FFF' : '#333'
          self.context.textAlign = 'center'
          // self.context.fillText(d.info['case-number'], d.x + (self.iconSize[0] / 2), d.y + (self.iconSize[1] / 2) + adjustedy)
        }
      })
    },
    drawLink (params) {
      const self = this

      this.links.forEach(function (d, i) {
        if (self.dataset.name === 'clusters') {
          // draw line connection
          var posX = (self.iconSize[0] / 2)
          var posY = (self.iconSize[1] / 2) + 10
          if (d.target.isExternal) {
            posY = 10
            posX = 0
          }

          const ax = d.source.x + (self.iconSize[0] / 2)
          const ay = d.source.y + (self.iconSize[1] / 2) + 10
          const bx = d.target.x + posX
          const by = d.target.y + posY
          const [cpx, cpy] = getControlPoint(ax, ay, bx, by)

          self.context.beginPath()
          self.context.strokeStyle = '#C0CAC9'
          self.context.moveTo(ax, ay)
          self.context.quadraticCurveTo(cpx, cpy, bx, by)
          self.context.lineWidth = 1
          self.context.stroke()

          // draw dots
          self.context.beginPath()
          self.context.arc(d.source.x + (self.iconSize[0] / 2), d.source.y + (self.iconSize[1] / 2) + 10, 2, 0, 2 * Math.PI)
          self.context.fillStyle = '#C0CAC9'
          self.context.fill()

          self.context.beginPath()
          self.context.arc(d.target.x + posX, d.target.y + posY, 2, 0, 2 * Math.PI)
          self.context.fillStyle = '#C0CAC9'
          self.context.fill()
        }
      })

      this.nodesAll.forEach(function (d, i) {
        // show short info
        if (self.dataset.showinfo) {
          var textArr = self.wrap(d.info['connection-description'], self.iconSize[0] + 20)
          var lineHeight = 8
          var posX = self.iconSize[0] / 2
          var posY = self.iconSize[1]
          if (d.isExternal) {
            posX = 0
            posY = 20
            textArr = ['Cluster connection']
          }
          self.context.fillStyle = '#333'
          self.context.font = `${8}px CuratorRegular`
          if (textArr.length > 2) {
            self.context.font = `${6}px CuratorRegular`
            lineHeight = 6
            textArr.forEach((element, index) => {
              self.context.fillText(element, d.x + posX, d.y + (posY + ((index + 1) * lineHeight)))
            })
          } else {
            textArr.forEach((element, index) => {
              self.context.fillText(element, d.x + posX, d.y + (posY + ((index + 1) * lineHeight)))
            })
          }
        }

        // self.linkConnection(d, i)
      })
    },
    linkConnection (d, index) {
      if (this.dataset.name !== 'clusters' || d.nindex < 0 || (!d.info['case-connections-within-cluster'] && !d.info['case-connections-outside-cluster'])) return

      if (this.dataset.externalconnection) {
        // draw external link
        if (d.info['case-number'] === this.dataset.externalconnection['case-number']) {
          this.dataset.externalconnection.x = d.x
          this.dataset.externalconnection.y = d.y
        }
        var addDotY = 5
        if (d.info.age < 14 && d.info.age > 2) {
          addDotY = 10
        }

        this.context.beginPath()
        this.context.strokeStyle = '#C0CAC9'
        this.context.moveTo(this.dataset.externalconnection.x + (this.iconSize[0] / 2), this.dataset.externalconnection.y + (this.iconSize[1] / 2) + addDotY)
        this.context.lineTo(this.width - 50, 50 + 4)
        this.context.lineWidth = 0.5
        this.context.stroke()

        // draw dot
        this.context.beginPath()
        this.context.arc(this.dataset.externalconnection.x + (this.iconSize[0] / 2), this.dataset.externalconnection.y + (this.iconSize[1] / 2) + addDotY, 2, 0, 2 * Math.PI)
        this.context.fillStyle = '#C0CAC9'
        this.context.fill()

        this.context.beginPath()
        this.context.arc(this.width - 50, 50, this.iconSize[0] / 2, 0, 2 * Math.PI)
        this.context.fillStyle = '#333'
        this.context.fill()

        var fontSize = this.iconSize[0] * 0.40 > 10 ? 10 : this.iconSize[0] * 0.40
        this.context.font = `${fontSize}px CuratorRegular`
        this.context.fillStyle = '#FFF'
        this.context.textAlign = 'center'
        this.context.fillText(this.dataset.externalconnection['case-connections-outside-cluster'], this.width - 50, 50 + 4)

        this.context.font = `${8}px CuratorRegular`
        this.context.fillStyle = '#6e6e6e'
        this.context.textAlign = 'center'
        this.context.fillText('Cluster connection', this.width - 50, 50 + 10 + (this.iconSize[0] / 2))
      }
    },
    iconColor (d, color) {
      var fillColor = '#333'
      // critical = '#E18425'

      if (this.dataset.slideindex === undefined || this.dataset.slideindex > 1) {
        if (d.info['imported or local'] !== 'local') {
          fillColor = '#B8B8B8'
        }
        if (d.info['imported or local'] === undefined) {
          fillColor = '#878888'
        }
      }
      if (this.dataset.slideindex === undefined || this.dataset.slideindex > 2) {
        if (d.info.condition === 'recovered') {
          fillColor = '#02C7BF'
        }
      }
      if (this.dataset.name === 'cases' && d.info.isNewCase) {
        fillColor = '#4A5055'
      }
      if (d.info.condition === 'died') {
        // fillColor = '#952370'
        fillColor = '#727F8D'
      }

      // invert selection
      this.context.globalCompositeOperation = 'source-atop'

      this.context.fillStyle = fillColor
      // this.context.fillRect(d.x + 1, d.y + 1, this.iconSize[0] - 3, this.iconSize[1] - 3)
      this.context.fillRect(d.x, d.y, this.iconSize[0], this.iconSize[1])

      // reset
      this.context.globalCompositeOperation = 'source-over'
    },
    wrap (text, maxWidth) {
      if (text === undefined) return []

      var lines = []
      var words = text.replace(/\n\n/g, ' ` ').replace(/(\n\s|\s\n)/g, '\r')
        .replace(/\s\s/g, ' ').replace('`', ' ').replace(/(\r|\n)/g, ' ' + ' ').split(' ')
      var space = this.context.measureText(' ').width
      var width = 0
      var line = ''
      var word = ''
      var len = words.length
      var w = 0
      var i
      for (i = 0; i < len; i++) {
        word = words[i]
        w = word ? this.context.measureText(word).width : 0
        if (w) {
          width = width + space + w
        }
        if (w > maxWidth) {
          return []
        } else if (w && width < maxWidth) {
          line += (i ? ' ' : '') + word
        } else {
          !i || lines.push(line !== '' ? line.trim() : '')
          line = word
          width = w
        }
      }
      if (len !== i || line !== '') {
        lines.push(line)
      }
      return lines
    },
    hex2rgba (hex, alpha = 1) {
      const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16))
      return `rgba(${r},${g},${b},${alpha})`
    }
  },
  mounted () {
    var scale = window.devicePixelRatio // Change to 1 on retina screens to see blurry canvas.
    var width = this.$el.parentElement.offsetWidth
    var height = this.$el.parentElement.offsetHeight
    if (height > window.innerHeight) {
      height = window.innerHeight
    }
    this.width = width
    this.height = height
    this.startCenter = [width * 0.5, height * 0.5]
    this.endCenter = [width * 0.5, height * 0.5]

    this.canvas = d3.select(this.$el)
    this.canvas.style('width', width + 'px')
    this.canvas.style('height', height + 'px')
    this.canvas.attr('width', width * scale)
    this.canvas.attr('height', height * scale)
    this.context = this.canvas.node().getContext('2d')
    this.context.scale(scale, scale)
  }
}

function getControlPoint (ax, ay, bx, by) {
  const mx = (ax + bx) / 2
  const my = (ay + by) / 2
  const d = Math.pow(ax - bx, 2) + Math.pow(ay - by, 2)
  return [mx, my - 0.0003 * d]
}
</script>

<style lang="scss" scoped>
  canvas.graph-canvas {
    image-rendering: -moz-crisp-edges;
    image-rendering: -webkit-crisp-edges;
    image-rendering: pixelated;
    image-rendering: crisp-edges;
  }
</style>
